import { AssetTypeWithAssets } from '../../types/asset';
import { SingleObjectType } from '../../types/list';
import { SelectedAssets } from '../../types/questions';

/*
  Builds a list of assets that are selected in the custom asset selection.

  @param assetTypesWithAssets - All asset types with their assets.
  @param selectedAssets - The selected assets and asset types to build the list from.
  @returns A list of assets that are selected in the custom asset selection.
*/
export function buildCustomAssetList(
  assetTypesWithAssets: Record<number, AssetTypeWithAssets>,
  selectedAssets: SelectedAssets,
): SingleObjectType[] {
  const assetTypeIds = new Set((selectedAssets?.asset_types ?? []).map(Number));
  const assetIds = new Set((selectedAssets?.assets ?? []).map(Number));
  const seenAssetIds = new Set<number>();
  const filteredAssets: SingleObjectType[] = [];
  Object.values(assetTypesWithAssets).forEach((type) => {
    type.assets.forEach((asset) => {
      if ((assetTypeIds.has(type.id) || assetIds.has(asset.id)) && !seenAssetIds.has(asset.id)) {
        seenAssetIds.add(asset.id);
        filteredAssets.push({
          id: String(asset.id),
          name: `${asset.name} | ${asset.code}`,
          code: asset.code,
          list_id: '',
          account_id: '',
        });
      }
    });
  });
  return filteredAssets;
}
